import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  type: "submit",
  class: "btn btn-success mt-2 w-100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "py-2 text-secondary" }, " Наведите камеру на QR код расположенный на терминале! После определения QR появится кнопка запуска мойки! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_loader = _resolveComponent("b-loader")!
  const _component_qr_stream = _resolveComponent("qr-stream")!
  const _component_base_popup = _resolveComponent("base-popup")!

  return (_openBlock(), _createBlock(_component_base_popup, {
    onClose: _ctx.close,
    title: "Запуск мойки по QR коду",
    onSubmit: _ctx.washStart
  }, {
    body: _withCtx(() => [
      (_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_b_loader, {
            key: 0,
            class: "m-auto",
            style: {"width":"34px"}
          }))
        : (_ctx.state.terminal_step > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", null, " Сумма оплаты " + _toDisplayString(_ctx.amount) + " руб. ", 1),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  class: "btn btn-success mt-2 w-100",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.terminalPay()))
                }, " Оплатить ")
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_qr_stream, { onDecode: _ctx.onDecode }, null, 8, ["onDecode"]),
              (_ctx.qr_code)
                ? (_openBlock(), _createElementBlock("button", _hoisted_1, " Запустить "))
                : _createCommentVNode("", true),
              _hoisted_2
            ], 64))
    ]),
    _: 1
  }, 8, ["onClose", "onSubmit"]))
}